import { REPORT_TITLE_MAX_LENGTH } from '../../../../forms/reportForm/types';

/**
 * Builds the default "Duplicate Report" title from a source report (or template)
 * title.
 *
 * The transform truncates the source title so the combined output (truncated
 * title + optional ellipsis + ` [COPY]` suffix) stays within
 * {@link REPORT_TITLE_MAX_LENGTH} characters, preventing the user from landing
 * on an invalid pre-filled value.
 *
 * Used by both the report-listing duplicate flow and the report-viewer
 * duplicate flow (`CopyReportModal`) so the two stay in lock-step.
 */
const TRUNCATE_INDICATOR = '...';
const COPY_SUFFIX = ' [COPY]';
const TITLE_TRUNCATE_LENGTH = REPORT_TITLE_MAX_LENGTH - COPY_SUFFIX.length - TRUNCATE_INDICATOR.length;

export const computeDuplicateReportTitle = (sourceTitle: string): string => {
  if (!sourceTitle) {
    return '';
  }
  const truncated =
    sourceTitle.length > TITLE_TRUNCATE_LENGTH
      ? `${sourceTitle.slice(0, TITLE_TRUNCATE_LENGTH)}${TRUNCATE_INDICATOR}`
      : sourceTitle;
  return `${truncated}${COPY_SUFFIX}`;
};
